import DialogTitleLayout from "../layout/DialogTitleLayout";

function DialogTitle ( props ) {

    return <DialogTitleLayout {...props} />

}

export default DialogTitle;
